
import { Component, Mixins, Watch } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import LoadModule from "@/store/modules/barcodeSystem/load";
import * as modals from "@/lib/modals";

@Component({
  name: modals.unlockLoadModal
})
export default class UnlockLoadModal extends Mixins(mixin) {
  loadModule: LoadModule = getModule(LoadModule);

  async unlock() {
    this.isLoading = true;
    for (let index = 0; index < this.selectedItems.length; index++) {
      let load = this.selectedItems[index];

      try {
        await this.loadModule.unlockLoad(load);
        this.addActionResult({
          number: load.id,
          success: true,
          message: `Load ${load.loadName} successfully unlocked.`
        });
      } catch (error) {
        this.addActionResult({
          number: load.id,
          success: false,
          message: error.response.data.message,
          errors:
            error.response.data && error.response.data.errors ? error.response.data.errors : null,
          errorMessages:
            error.response.data && error.response.data.errorMessages
              ? error.response.data.errorMessages
              : null
        });
      }
    }
    await this.refreshLoads();
    this.hideModal();
  }

  async refreshLoads(){
    await this.loadModule.updateLoadsAfterAction(this.selectedItems);
  }
}
